import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import { listAssistantSessions } from "../../api/endpoints-assistant.ts";
import { useAsync } from "../../lib/useAsync.ts";
import { useI18n } from "../../i18n/index.tsx";
import { Button } from "../../components/Button.tsx";
import { ErrorBanner } from "../../components/Feedback.tsx";
import { conversationTitleFrom } from "./conversationTitle.ts";

/** Owner-only conversations have their own routes and never inherit project navigation. */
export function ConversationHistory({ compact = false, onNavigate }: { compact?: boolean; onNavigate?: () => void }) {
  const { t, formatRelative } = useI18n();
  const { pathname } = useLocation();
  const [cursor, setCursor] = useState<string | undefined>();
  const history = useAsync((signal) => listAssistantSessions({ limit: compact ? 5 : 20, ...(cursor ? { cursor } : {}) }, signal), [cursor, pathname]);
  useEffect(() => {
    const refresh = () => { setCursor(undefined); history.reload(); };
    window.addEventListener("maestros:assistant-history-changed", refresh);
    return () => window.removeEventListener("maestros:assistant-history-changed", refresh);
  }, [history.reload]);
  return <section className={compact ? "nav-recent" : "home-recent"} aria-label={t("home.conversations")}>
    <h2 className={compact ? "nav-section-title" : undefined}>{t("home.conversations")}</h2>
    {history.loading ? <p role="status">{t("common.loading")}</p> : history.error ? <ErrorBanner error={history.error} onRetry={history.reload} /> : history.data?.items.length ? <>
      <ul className={compact ? "nav-list" : "stack"}>
        {history.data.items.map((item) => <li key={item.id}>
          <Link to={`/chats/${item.id}`} className={compact ? "nav-link nav-link--recent" : "recent-item card"} onClick={onNavigate}>
            <span className="truncate">{conversationTitleFrom(item.first_message ?? "") ?? t("home.askFallbackTitle")}</span>
            {!compact ? <span className="subtle">{formatRelative(item.last_activity_at)}</span> : null}
          </Link>
        </li>)}
      </ul>
      {history.data.next_cursor ? <Button size="sm" onClick={() => setCursor(history.data!.next_cursor!)}>{t("home.moreConversations")}</Button> : null}
      {cursor ? <Button size="sm" onClick={() => setCursor(undefined)}>{t("home.latestConversations")}</Button> : null}
    </> : <p className="nav-empty">{t("home.noConversations")}</p>}
  </section>;
}
